import Ufs from "./enum/ufs";

export default class NaturezaOperacaoObservacaoModel {
    id?: number = null;
    naturezaOperacaoId: number = null;
    uf: Ufs = null;
    ufDescricao: string = null;
    observacao: string = null;
}
